// Theme exports
export * from './theme';

// MUI theme exports
export {
  baseThemeOptions,
  createBilldaTheme,
  createBilldaThemeWithPreset,
  createBilldaThemeWithMode
} from './mui/theme';

// Type exports
export * from './types';

// Utility exports
export * from './utils';

// Component exports
export * from './components';

// Validation exports
export * from './validation';

// API exports (Development tools)
export * from './api/timeApi';

// Axios client factory and error handling
export * from './api';

// Hook exports (Development tools)
export * from './hooks/useTimeManipulation';

// Logo asset paths
export const BILLDA_LOGOS = {
  primary: '/src/assets/logos/primary.svg',
  secondary: '/src/assets/logos/secondary.svg',
  iconOnly: '/src/assets/logos/icon-only.svg',
  monochromeBlack: '/src/assets/logos/monochrome-black.png',
  monochromeWhite: '/src/assets/logos/monochrome-white.png',
} as const;